import React, { useState, useEffect } from "react";
import Logo from "../assets/logo.png";
import { NavLink, useNavigate } from "react-router-dom";
import { FaRegCircleUser } from "react-icons/fa6";
// import { FaRegCircleUser } from "react-icons/pi";
import { HiMenu, HiX } from "react-icons/hi"; // Hamburger and close icons
import { useSelector } from "react-redux";
import { useDispatch } from 'react-redux';
import { userLogout } from '../redux/AuthSlice';
import { new_logo } from "../assets/updated_assests/assets";
import { useGetTopSectionQuery } from "../services/Api";

const Header = () => {
    const [scrolled, setScrolled] = useState(false);
    const [menuOpen, setMenuOpen] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const auth = useSelector((data) => data?.auth);
    const userDetails = auth && auth?.userDetail
    const { data, isLoading } = useGetTopSectionQuery();
    const getTitle = () => {
        if (Array.isArray(data) && data.length > 0 && data[0]?.title) {
            return data[0].title;
        }
        return "";
    };
    useEffect(() => {

        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Adds a smooth scrolling effect
        });
    }, [])
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth", // Adds a smooth scrolling effect
        });
    };
    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const LogoutHandle = () => {
        dispatch(userLogout(null));
        navigate('/')
        // window.location.reload();
    }
    const EditHandle = () => {
        // dispatch(userLogout(null));
        navigate('/edit-profile')
        // window.location.reload();
    }


    return (
        <div className="">
            <div className="top_header bg-dark text-center p-4">
                <p
                    className="italic font-bold font-roboto-mono capitalize text-sm text-white"
                    dangerouslySetInnerHTML={{ __html: getTitle() }}
                />
            </div>
            <div
                className={` w-full z-[999] transition duration-300 bg-bgprimary shadow-lg
                    }`}
            >
                <div
                    className={`max-w-[1200px] mx-auto flex items-center justify-between px-4 ${scrolled ? "py-4" : "py-6"
                        }`}
                >
                    {/* Logo */}
                    <NavLink to={`/`}  >
                        <img src={new_logo} alt="Logo" className="h-8 md:h-10 w-[180px] object-contain" />
                    </NavLink>

                    {/* Hamburger Icon (Mobile) */}
                    <button
                        className={`text-dark md:hidden  text-2xl absolute right-4 z-[51] ${scrolled ? 'top-20 fixed' : 'top-20'} `}
                        onClick={() => { toggleMenu(); handleScrollToTop() }}
                        aria-label="Toggle menu"
                    >
                        {menuOpen ? <HiX /> : <HiMenu />}
                    </button>

                    {/* Navigation Links */}


                    <div className="lg:-ml-16">
                        <ul
                            className={`fixed inset-0 bg-bgprimary  z-50 flex flex-col items-center justify-center space-y-8 transition-transform transform ${menuOpen ? "translate-x-0" : "translate-x-full"
                                } md:static md:flex md:flex-row md:space-y-0 md:space-x-0 md:bg-transparent md:translate-x-0`}
                        >
                            <li>
                                <NavLink
                                    to={`https://www.kickstarter.com/projects/westbreeze
travel/packing-cubes-hanging-wardrobe-instantly`}
                                    target="_blank"
                                    className={({ isActive }) =>
                                        isActive
                                            ? "text-white px-6 py-3 bg-dark font-quicksand font-bold"
                                            : "text-dark px-6 py-3 font-quicksand font-bold"
                                    }
                                    onClick={() => { setMenuOpen(false); handleScrollToTop() }}
                                >
                                    Products
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={`/packing-list`}
                                    className={({ isActive }) =>
                                        isActive
                                            ? "text-white px-6 py-3 bg-dark font-quicksand font-bold "
                                            : "text-dark px-6 py-3 font-quicksand font-bold"
                                    }
                                    onClick={() => { setMenuOpen(false); handleScrollToTop() }}
                                >
                                    Packing List
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to={`/about`}
                                    className={({ isActive }) =>
                                        isActive
                                            ? "text-white px-6 py-3 bg-dark font-quicksand font-bold "
                                            : "text-dark px-6 py-3 font-quicksand font-bold"
                                    }
                                    onClick={() => { setMenuOpen(false); handleScrollToTop() }}
                                >
                                    About Us
                                </NavLink>
                            </li>
                            {/* Responsive My Lounge Button */}
                            {auth?.isLoggedIn ?
                                <li className="block md:hidden relative">
                                    <NavLink
                                        // to={auth?.userRole == 'ADMIN' ? `/dashboard` : auth?.userRole == 'TRAVELLER' ? "/travel-packing" : `/profile`}
                                        to={auth?.userRole == 'ADMIN' ? `/dashboard` : `/profile`}
                                        className={({ isActive }) =>
                                            isActive
                                                ? "flex items-center gap-3 border-2 border-dark px-6 py-3 text-dark bg-white font-quicksand font-bold "
                                                : "flex items-center gap-3 border-2 border-dark px-6 py-3 text-dark bg-white font-quicksand font-bold"
                                        }
                                        onClick={() => { setMenuOpen(false); handleScrollToTop() }}
                                    >
                                        <FaRegCircleUser />
                                        {userDetails?.firstName}
                                    </NavLink>
                                    <div className="absolute top-full left-0 w-24 bg-bgprimary rounded-md">
                                        <ul>
                                            <li>
                                                <span onClick={LogoutHandle} className={`text-dark hover:cursor-pointer font-quicksand font-bold`} >Logout</span>
                                            </li>
                                            {/* {auth?.userRole == 'USER' && (
                                            <li>
                                                <span onClick={EditHandle} className={`text-dark hover:cursor-pointer font-quicksand font-bold`} >Edit Profile</span>
                                            </li>
                                        )} */}
                                        </ul>
                                    </div>
                                </li>
                                :
                                <li className="block md:hidden">
                                    <NavLink
                                        to={`/login`}
                                        className={({ isActive }) =>
                                            isActive
                                                ? "flex items-center gap-3 border-2 border-dark px-6 py-3 text-dark bg-white font-quicksand font-bold "
                                                : "flex items-center gap-3 border-2 border-dark px-6 py-3 text-dark bg-white font-quicksand font-bold"
                                        }
                                        onClick={() => { setMenuOpen(false); handleScrollToTop() }}
                                    >
                                        <FaRegCircleUser />
                                        Sign in
                                    </NavLink>
                                </li>
                            }
                        </ul>
                    </div>
                    {/* Desktop My Lounge Button */}
                    {auth?.isLoggedIn ?
                        <div className="relative group">

                            <NavLink
                                // to={auth?.userRole == 'ADMIN' ? `/dashboard` : auth?.userRole == 'TRAVELLER' ? "/travel-packing" : `/profile`}
                                to={auth?.userRole == 'ADMIN' ? `/dashboard` : `/profile`}
                                onClick={handleScrollToTop}
                                className={({ isActive }) =>
                                    isActive
                                        ? "hidden md:flex items-center gap-3 border-2 border-dark px-3 py-2 text-dark bg-white font-quicksand font-bold "
                                        : "hidden md:flex items-center gap-3 border-2 border-dark px-3 py-2 text-dark bg-white font-quicksand font-bold"
                                }
                            >
                                <FaRegCircleUser />
                                <span className=" capitalize" >
                                    {userDetails?.firstName}
                                </span>

                            </NavLink>
                            <div className=" z-50 absolute top-full left-0 w-[110px] bg-white p-2 border-2 border-dark  hidden transition-opacity duration-300 group-hover:block">
                                <ul>
                                    {/* {
                                    auth?.userRole == 'ADMIN' ?
                                        <li>
                                            <NavLink to="/dashboard" className={`text-dark  font-quicksand font-bold`} >
                                                Dashboard
                                            </NavLink>
                                        </li>
                                        :
                                        <li>
                                            <NavLink to="/profile" className={`text-dark  font-quicksand font-bold`} > Profile </NavLink>
                                        </li>
                                } */}


                                    <li>
                                        <span onClick={LogoutHandle} className={`text-dark hover:cursor-pointer font-quicksand font-bold`} >Logout</span>
                                    </li>
                                    {/* {auth?.userRole == 'USER' && (
                                    <li>
                                        <span onClick={EditHandle} className={`text-dark hover:cursor-pointer font-quicksand font-bold`} >Edit Profile</span>
                                    </li>
                                )} */}

                                </ul>
                            </div>

                        </div>
                        :
                        <NavLink
                            to={`/login`}
                            onClick={handleScrollToTop}
                            className={({ isActive }) =>
                                isActive
                                    ? "hidden md:flex items-center gap-1 border-2 border-dark px-3 py-3 text-dark bg-white font-quicksand font-bold "
                                    : "hidden md:flex items-center gap-1 border-2 border-dark px-3 py-3 text-dark bg-white font-quicksand font-bold"
                            }
                        >
                            <FaRegCircleUser />
                            Sign in
                        </NavLink>

                    }


                </div>
            </div>
        </div>

    );
};

export default Header;
